(ns app.front.view.workspace.add-dummy
  (:require [app.domain.address.model :as address-model]
            [app.front.entities :as entities]
            [app.front.ui.select :as ui-select]
            [app.front.ui.util :as uiu]
            [app.front.view.create-application.create-v2 :as create-v2]
            [app.front.view.create-application.gis-search :as gis-search]
            [app.front.view.workspace.address :as workspace-address]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::create-workspace
  (fn [_ [_ params on-created-dispatch]]
    {:comm/command {:command    :workspace/create
                    :data       params
                    :notify     {:success :workspace/created}
                    :on-success [::workspace-added on-created-dispatch]}}))

(rf/reg-event-fx ::workspace-added
  (fn [_ [_ on-created-dispatch status result]]
    {:dispatch-n [[::entities/apply-changes status result]
                  [::clear]
                  (->> result
                       (entities/property-of-some-in-apply-changes :workspace/id)
                       (conj on-created-dispatch))]}))

(rf/reg-event-fx ::select-target
  (fn [{:keys [db]} [_ {:keys [municipality domain-group-id] :as target}]]
    {:db       (-> db
                   (assoc-in [::state :target] target)
                   (assoc-in [::state :create-candidate] nil))
     :dispatch [::gis-search/address-search-input
                domain-group-id
                [municipality]
                (-> db ::gis-search/address-search-results :search-value)]}))

(rf/reg-event-db ::select-property
  (fn [db [_ feature]]
    (-> db
        (assoc-in [::state :create-candidate] feature))))

(defn targets-handler [group-ids+domain-group-ids+scopes+prop-i18n-mapping]
  (->> group-ids+domain-group-ids+scopes+prop-i18n-mapping
       (map (fn [[group-id
                  domain-group-id
                  {{:municipality/keys [country number subdivision] :keys [municipality-name]} :scope/municipality
                   :scope/keys                                                                 [permit-type]}
                  property-i18n-mapping]]
              {:country               country
               :municipality          number
               :subdivision           subdivision
               :permit-type           permit-type
               :domain-group-id       domain-group-id
               :municipality-name     municipality-name
               :group-name            "group-name"
               :authority-group-id    group-id
               :property-i18n-mapping property-i18n-mapping}))
       (sort-by :municipality-name)))

(rf/reg-event-db ::clear
  (fn [db _]
    (-> db
        (dissoc ::state)
        (dissoc ::create-v2/manual-address))))

(rf/reg-sub ::state
  :-> ::state)

(rf/reg-sub ::target
  :<- [::state]
  :-> :target)

(rf/reg-sub ::create-candidate
  :<- [::state]
  :-> :create-candidate)

(rf/reg-sub ::address
  :<- [::create-candidate]
  (fn [feature _]
    (-> feature :address)))

(rf/reg-sub ::create-disabled?
  :<- [::address]
  :<- [::create-v2/manual-address]
  (fn [[address manual-address] _]
    (->> [address manual-address]
         (map address-model/address-checker)
         (some nil?)
         not)))

(defn uniques? [coll k]
  (->> coll
       (map k)
       frequencies
       vals
       (apply max)
       (= 1)))

(defn permit-type-str-fn [tr]
  (fn [item]
    (when item
      (tr [(:permit-type item)]))))

(defn val->str-fn [tr targets]
  (cond
    (uniques? targets :permit-type)
    (permit-type-str-fn tr)
    (uniques? targets :municipality-name)
    :municipality-name
    :else
    (comp (partial str/join ", ")
          (juxt :municipality-name (permit-type-str-fn tr)))))

(def items
  (uiu/wrap-in :div :div.mx-2.mb-2))

(defn on-select-address [feature]
  (>evt [::select-property feature]))

(defn- selectable-result?
  [{:keys [address]}]
  (some? (:address/full-address address)))

(defn create-workspace [{:keys [on-created-dispatch
                                group-ids+domain-group-ids+scopes+prop-i18n-mapping]}]
  (r/with-let [*adding? (r/atom false)]
    (cond
      @*adding?
      [:div.flex.w-full.justify-center
       (cc/loading-spinner {:with-overlay false})]

      ;; e.g. an upper-tier authority group without municipalities has nothing to search or create in
      (empty? group-ids+domain-group-ids+scopes+prop-i18n-mapping)
      [items
       (cc/inline-notification
         {:kind              :info
          :class-name        "min-w-0 max-w-full w-full"
          :hide-close-button true
          :title             ((<sub [:tr]) [:workspace.dummy/no-targets])
          :subtitle          ""})]

      :else
      (let [candidate                                                                                                      (<sub [::create-candidate])
            address                                                                                                        (<sub [::address])
            manual-address                                                                                                 (<sub [::create-v2/manual-address])
            targets                                                                                                        (targets-handler group-ids+domain-group-ids+scopes+prop-i18n-mapping)
            {:keys [country municipality subdivision authority-group-id domain-group-id permit-type property-i18n-mapping]
             :as   target}                                                                                                 (or (<sub [::target])
                                                                                                                               (first targets))
            tr                                                                                                             (->> (<sub [:tr])
                                                                                                                                (i18n-model/wrap-tr-fn property-i18n-mapping))]
        [items
         (when (-> targets count (> 1))
           [ui-select/select {:allow-empty? false
                              :class-name   "full-width-select"
                              :label-text   (tr [:workspace.dummy/select-target])
                              :id           "workspace-create-target"
                              :values       targets
                              :val->str     (val->str-fn tr targets)
                              :on-change    #(>evt [::select-target %])
                              :light        true
                              :value        target}])
         [:p.p-0.text-xs (tr [:workspace.dummy/input-address])]
         [gis-search/address-search
          (util/mmap {:domain-group-id       domain-group-id
                      :municipalities        [municipality]
                      :subdivision           subdivision
                      :on-select-address     on-select-address
                      :on-select-location    on-select-address
                      :selectable-result?    selectable-result?
                      :result-list-min-width "700px"
                      :show-existing?        false
                      :light                 true}
                     tr)]
         (when (and address (address-model/address-checker address))
           ;; bad address, input manually
           [workspace-address/address-input-fields
            (util/mmap {:address             manual-address
                        :field-css-classes   {:default "w-full mb-2"}
                        :field-wrapper-class "flex mb-4 flex-wrap"
                        :set-addr-evt        ::create-v2/set-manual-address}
                       tr subdivision)])
         (if permit-type
           [cc/button
            {:on-click (fn [_]
                         (reset! *adding? true)
                         (>evt [::create-workspace
                                (merge candidate
                                       (util/mmap {:address (cond
                                                              (-> address
                                                                  address-model/address-checker
                                                                  nil?) address
                                                              :else manual-address)}
                                                  authority-group-id
                                                  country
                                                  municipality
                                                  permit-type))
                                on-created-dispatch]))
             :disabled (<sub [::create-disabled?])}
            (tr [:workspace/create])]
           (cc/loading-spinner {:with-overlay false}))]))))
